import React, { memo } from 'react';

interface IfProps {
  /**
   * Renders children **iff** (if and only if) this condition evaluates to `true`;
   * does a strict check and "truthy" values will not be considered `true`.
   */
  condition: boolean;
  /**
   * The react children are rendered if `condition === true`. Use the render-prop variant of children, if you do not wish for the JSX
   * of the children to be evaluated when the condition falsy.
   */
  // eslint-disable-next-line @typescript-eslint/ban-types
  children: React.ReactNode | Function;
}

const If: React.FC<IfProps> = ({ condition, children }) => {
  if (condition === true) {
    return typeof children === 'function' ? children() : children;
  }
  return null;
};

/**
 * Just a simple conditional component; evaluates the prop `condition` and renders the children if and only if `condition` evaluates to `true`.
 *
 * **Note**: This component is memoized using [React.memo](https://reactjs.org/docs/react-api.html#reactmemo).
 * @component
 */
export default memo<IfProps>(If);
